//import { useContext } from "react"
import { useNavigate } from "react-router-dom";
import { context, useAuth } from "./context/authContext";
import lumin from "./assets/lumin.jpg";
import bim from "./assets/bim.jpg";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Cards from "./components/Cards";
import FormularioEntrada from "./components/formularios/FormularioTe1Express";
import { useState } from "react";
import FormularioTe1Express from "./components/formularios/FormularioTe1Express";
import SignUpInfo from "./components/formularios/SignUpInfo";
import PersonalInfo from "./components/formularios/PersonalInfo";
import Form from "./components/formularios/Form";
import Form2 from "./components/formularios/Form2";
import Form3 from "./components/formularios/Form3";
import Form4 from "./components/formularios/Form4";
import Form5 from "./components/formularios/Form5";
import Form6 from "./components/formularios/Form6";
import Form7 from "./components/formularios/Form7";
import Form8 from "./components/formularios/Form8";
import Form9 from "./components/formularios/Form9";
import Form10 from "./components/formularios/Form10";
import Form11 from "./components/formularios/Form11";
import Form12 from "./components/formularios/Form12";
import Form13 from "./components/formularios/Form13";
import Form14 from "./components/formularios/Form14";
import Form15 from "./components/formularios/Form15";
import Form16 from "./components/formularios/Form16";
import Form17 from "./components/formularios/Form17";
import Form18 from "./components/formularios/Form18";
import Form19 from "./components/formularios/Form19";
import Form20 from "./components/formularios/Form20";



import "./App.css";


export function Home() {
  const [showForm, setShowForm] = useState(false);
  const [showForm2, setShowForm2] = useState(false);
  const [showForm3, setShowForm3] = useState(false);
  const [showForm4, setShowForm4] = useState(false);
  const [showForm5, setShowForm5] = useState(false);
  const [showForm6, setShowForm6] = useState(false);
  const [showForm7, setShowForm7] = useState(false);
  const [showForm8, setShowForm8] = useState(false);
  const [showForm9, setShowForm9] = useState(false);
  const [showForm10, setShowForm10] = useState(false);
  const [showForm11, setShowForm11] = useState(false);
  const [showForm12, setShowForm12] = useState(false);
  const [showForm13, setShowForm13] = useState(false);
  const [showForm14, setShowForm14] = useState(false);
  const [showForm15, setShowForm15] = useState(false);
  const [showForm16, setShowForm16] = useState(false);
  const [showForm17, setShowForm17] = useState(false);
  const [showForm18, setShowForm18] = useState(false);
  const [showForm19, setShowForm19] = useState(false);
  const [showForm20, setShowForm20] = useState(false);
  //const authContext = useContext(context)
  //const authContext = useAuth() se comenta para solo traer los datos y no el objeto completo
  const { user, logout, loading } = useAuth();
  console.log(user);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) return <h1>loading...</h1>;

  return (
    <>
      <Navbar />
      <div style={{ display: "flex" }}>
        <Sidebar
          showForm={showForm}
          setShowForm={setShowForm}
          showForm2={showForm2}
          setShowForm2={setShowForm2}
          showForm3={showForm3}
          setShowForm3={setShowForm3}
          showForm4={showForm4}
          setShowForm4={setShowForm4}
          showForm5={showForm5}
          setShowForm5={setShowForm5}
          showForm6={showForm6}
          setShowForm6={setShowForm6}
          showForm7={showForm7}
          setShowForm7={setShowForm7}
          showForm8={showForm8}
          setShowForm8={setShowForm8}
          showForm9={showForm9}
          setShowForm9={setShowForm9}
          showForm10={showForm10}
          setShowForm10={setShowForm10}
          showForm11={showForm11}
          setShowForm11={setShowForm11}
          showForm12={showForm12}
          setShowForm12={setShowForm12}
          showForm13={showForm13}
          setShowForm13={setShowForm13}
          showForm14={showForm14}
          setShowForm14={setShowForm14}
          showForm15={showForm15}
          setShowForm15={setShowForm15}
          showForm16={showForm16}
          setShowForm16={setShowForm16}
          showForm17={showForm17}
          setShowForm17={setShowForm17}
          showForm18={showForm18}
          setShowForm18={setShowForm18}
          showForm19={showForm19}
          setShowForm19={setShowForm19}
          showForm20={showForm20}
          setShowForm20={setShowForm20}
          
        />

        {showForm && <Form />}

        {showForm2 && <Form2 />}

        {showForm3 && <Form3 />}

        {showForm4 && <Form4 />}

        {showForm5 && <Form5 />}

        {showForm6 && <Form6 />}

        {showForm7 && <Form7 />}

        {showForm8 && <Form8 />}

        {showForm9 && <Form9 />}

        {showForm10 && <Form10/>}

        {showForm11 && <Form11 />}

        {showForm12 && <Form12 />}

        {showForm13 && <Form13 />}

        {showForm14 && <Form14 />}

        {showForm15 && <Form15 />}

        {showForm16 && <Form16 />}

        {showForm17 && <Form17 />}

        {showForm18 && <Form18 />}

        {showForm19 && <Form19 />}

        {showForm20 && <Form20 />}


      </div>
    </>
  );
}
